import { exists } from '@/api'

export interface BatchTrcContentDataUpdateCondition {
  startNumFrom: string
  startNumTo: string
  convertHyoukiToFull: boolean
  contentDataFile: string
  memo: string
}

export function BatchTrcContentDataUpdateConditionFromJSON(
  json: any
): BatchTrcContentDataUpdateCondition {
  const _json = JSON.parse(json)

  return {
    startNumFrom: exists(_json, 'start_num_from') ? _json.start_num_from : '',
    startNumTo: exists(_json, 'start_num_to') ? _json.start_num_to : '',
    convertHyoukiToFull: exists(_json, 'convert_hyouki_to_full')
      ? _json.convert_hyouki_to_full
      : false,
    contentDataFile: exists(_json, 'content_data_file')
      ? _json.content_data_file
      : '',
    memo: exists(_json, 'memo') ? _json.memo : ''
  }
}
